/**
 * 리뷰 독의 단축키 표.
 *
 * 칩(패널)과 가이드가 **같은 표**를 봐야 두 표면이 서로 다른 키를 표시하지 않는다. 그래서 표를
 * 축마다 나누어 두지 않고 여기 모은다. 예약키는 `X` 제외 · `F` 실패 · `A` 결함 수용 · `K` 표기 ·
 * `C` 코멘트 · `S`/`Enter` 저장·검토 완료 · `M` 리뷰/뷰 모드 · `?` 가이드 · `↑↓` 이동이다. 결함
 * 순번 표는 예약키와 겹치지 않는다. `J` 는 비워 둔다.
 */

/**
 * 리뷰/뷰 모드 토글 키.
 *
 * 키가 `V`(뷰) 가 아니라 `M`(모드)인 이유는 한 키가 양방향을 모두 맡기 때문이다. 목적지 이름을
 * 키에 붙이면 돌아올 때 그 이름이 틀린다. 짝이 될 `R`(리뷰)은 이미 결함 순번 열네 번째 키다.
 * 그래서 두 키로 나누는 방법도 없다.
 *
 * 독(핸들러)·스위처(라벨 힌트)·가이드(표) 셋이 이 상수를 함께 쓴다.
 */
export const MODE_KEY = "m";

/**
 * 결함 태그 순번 → 단축키.
 *
 * 숫자열을 `0`(열 번째)까지 채우고, 그 바로 아래 Q 행으로 이어간다. Q 행 뒤에는 홈 로우의 `G`·`H`
 * 를 쓴다. 그래서 손이 홈 포지션에서 멀어지지 않고, 스물두 번째까지 키가 붙는다. 이 배열을 넘는
 * 태그는 키캡 없이 클릭으로만 토글한다.
 *
 * 순번은 서버가 준 `episode_quality_tags` 배열 위치다. 이 배열은 그 위치에 붙는 키만 정한다.
 */
export const TAG_HOTKEYS = [
  "1",
  "2",
  "3",
  "4",
  "5",
  "6",
  "7",
  "8",
  "9",
  "0",
  "q",
  "w",
  "e",
  "r",
  "t",
  "y",
  "u",
  "i",
  "o",
  "p",
  "g",
  "h",
] as const;

export const TAG_HOTKEY_INDEX = new Map<string, number>(
  TAG_HOTKEYS.map((key, index) => [key, index] as const),
);

/**
 * 실패 표시 토글 키.
 *
 * 결과는 기본 성공에서 시작하고 사람은 실패만 표시한다. 그래서 키도 하나다. 켜진 표시를 다시
 * 누르면 기본 성공으로 돌아간다. `F`(Failure)는 홈 포지션 왼손 키다.
 */
export const FAILURE_KEY = "f";

/**
 * 결함 수용 토글 키. `A`(Accept)는 `F` 와 같은 왼손 홈 로우 키다.
 *
 * 검증이 무효인 에피소드(또는 이미 수용한 에피소드)에서만 동작한다. 저장 전 draft 만 바꾼다.
 */
export const ACCEPT_KEY = "a";
